// app
export const SUBSCRIBE = 'subscribe'
export const UNSUBSCRIBE = 'unsubscribe'

// items
export const ITEMS_GET = '/items/data'

// user
export const USER_GET_AUTH_URL = 'app.getAuthUrl'
export const USER_GET = 'user.get'
export const USER_GET_WITHDRAWABLE = 'user.getWithdrawableToday'
export const USER_GET_ACTIVE_SEED_PAIR = 'user.getActiveSeedPair'
export const USER_CREATE_SEED_PAIR = 'user.createNewSeedPair'
export const USER_SET_TRADEURL = 'user.setTradeUrl'
export const USER_SET_NAME = 'user.changeName'
export const USER_SET_EMAIL = 'user.setEmail'
export const USER_CLAIM_FAUCET = 'user.claimFaucet'
export const USER_LOGOUT = '/auth/logout'
export const USER_DEPOSIT = 'deposit.inventory'
export const USER_PENDING_TRADES = 'user.getTradeHistory'
export const USER_REDEEM_REFCODE = 'user.affiliates.redeem'
export const GIFTCODE_CLAIM = 'user.claimCode'
export const GIFTCARD_CLAIM = 'user.claimGiftCard'

export const USER_REWARDS_GET = 'user.rewards'
export const USER_REWARDS_CLAIM = 'user.rewards.claim'
export const LEVEL_REWARDS_CLAIM = 'user.levelRewards.claim'
export const LEVEL_CASE_COOLDOWN = 'user.promo.levelCase.cooldown'
export const LEVEL_CASE_GET = 'user.promo.levelCase.getByTier'
export const LEVEL_CASE_OPEN = 'user.promo.levelCase.open'

// inventory
export const USER_STEAM_INVENTORY = 'user.inventory.steam'
export const USER_INVENTORY = 'user.inventory'
export const USER_INVENTORY_SWAP = 'user.inventory.swap'
export const USER_INVENTORY_CHECK_STOCK = 'user.inventory.checkStock'
export const USER_WITHDRAW = 'user.inventory.withdraw'
export const SELL_ITEMS = 'user.inventory.sell'

export const USER_CONNECTIONS = 'user.connections'
export const OAUTH_LINK = 'user.oauth.link'
export const OAUTH_UNLINK = 'user.oauth.unlink'

// crypto
export const CRYPTO_DEPOSIT_ADDRESS = 'crypto.getDepositAddress'

export const SKINSBACK_CREATE_ORDER = 'skinsback.getOrderUrl'

// chat
export const CHAT_SEND = 'chat.message'
export const CHAT_HISTORY = 'chat.history'

// games / wheel
export const GAME_WHEEL_BET = 'game.wheel.bet'

// games / spinners
export const GAME_SPINNERS_CREATE = 'game.spinners.create'
export const GAME_SPINNERS_JOIN = 'game.spinners.join'
export const GAME_SPINNERS_REQUEST_BOT = 'game.spinners.requestBot'
export const GAME_SPINNERS_EXPIRE = 'game.spinners.expire'

// games / coinflip
export const GAME_COINFLIP_CREATE = 'game.coinflip.create'
export const GAME_COINFLIP_JOIN = 'game.coinflip.join'

// games / cases
export const GAME_CASES_LIST = 'game.cases.list'
export const GAME_CASES_SLUG = 'game.cases.getBySlug'
export const GAME_CASES_OPEN = 'game.cases.open'

// games / case battles
export const GAME_CASE_BATTLES_LIST = 'game.caseBattles.getActive'
export const GAME_CASE_BATTLES_CREATE = 'game.caseBattles.create'
export const GAME_CASE_BATTLES_JOIN = 'game.caseBattles.join'
export const GAME_CASE_BATTLES_REQUEST_BOT = 'game.caseBattles.requestBot'
export const GAME_CASE_BATTLES_GET_ID = 'game.caseBattles.getById'

// games / dice
export const GAME_DICE_BET = 'game.dice.bet'
